import { render, staticRenderFns } from "./ModelDetail.vue?vue&type=template&id=1e99e3a3&scoped=true"
import script from "./ModelDetail.vue?vue&type=script&lang=js"
export * from "./ModelDetail.vue?vue&type=script&lang=js"
import style0 from "./ModelDetail.vue?vue&type=style&index=0&id=1e99e3a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99e3a3",
  null
  
)

export default component.exports